export default {
  nunitoSans: 'Nunito Sans, sans-serif',
  openSans: 'Open Sans, sans-serif'
}
